import React from "react";
import { Button, Col } from "react-bootstrap";
import "./Buttons.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
function BtnPrintPdf({ size, label, divId, disabled, fileName }) {

  const handlePrint = async () => {
    const input = document.getElementById(divId);

    // Convert HTML to canvas
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      // const imgWidth = canvas.width;
      // const imgHeight = canvas.height;
      // const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = 0;
      const imgY = 0;
      pdf.addImage(imgData, 'PNG', imgX, imgY, pdfWidth, pdfHeight);
      pdf.save(fileName);
      pdf.output("dataurlnewwindow"); //This is a key for printing
    });
  };

  return (
    <Col>
      <Button
        className="action-btn clear"
        size={size}
        onClick={handlePrint}
        disabled={disabled}
      >
        {label || `Print`}
      </Button>
    </Col>
  );
}

export default BtnPrintPdf;
